module.exports = __webpack_public_path__ + "media/images/pushup-06115533e6c1b39982222a2b4355f655.png";